import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const StackIcon = createIcon({
	viewBox: '0 0 22 22',
	path: (
		<>
			<path
				d="m18.8833 15.0332-8.0666 6.05-8.0667-6.05"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="m18.8833 11-8.0666 6.05L2.75 11"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				clipRule="evenodd"
				d="M10.8167.916 2.8508 7.1677l7.9659 6.1508 8.0666-6.1508L10.8167.916Z"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</>
	),
});
